<template>
    <section class="mb-3">

        <h4 class="text-muted">
            Vincular Estabelecimento
        </h4>

        <div class="input-wrapper">
            <v-flex>
                <app-select v-model="bind"
                            data-title="Estabelecimento"
                            data-menu-heading="Pesquisar"
                            data-menu-width="290px"
                            :data-button-gradient="true"
                            :data-items="items"
                            @search="v => search(v)"/>
                <button class="btn btn-round btn-primary" @click="bindEstablishment">Vincular</button>
            </v-flex>
        </div>

    </section>
</template>

<script>
    import EventBus from '@packages/event-bus'
    import AppSelect from '@components/Select'
    import _ from 'lodash'
    export default {

        components: {
            AppSelect,
        },

        data() {
            return {
                isLoading: false,
                bind: ''
            }
        },

        props: {
            dataId: {
                type: Number,
                required: true,
            },
        },
        computed: {
            items() {

                return _.map(this.$store.state.advertisers.establishments || [],
                    (user) => {
                        return {
                            id: user.id,
                            label: user.nome
                        }
                    }
                )
            },
        },

        methods: {
            async load() {
                await this.$loader.advertisers.establishments({
                    establishmentId: this.dataId,
                    search: '',
                })
            },

            async search(search) {
                await this.$loader.advertisers.establishments({
                    establishmentId: this.dataId,
                    search: search,
                })
            },
            async bindEstablishment() {
                if (!this.bind)
                    return

                this.isLoading = true

                await this.$api.advertisers.bindEstablishment({
                    advertiserId: this.dataId,
                    establishmentId: this.bind
                })

                this.isLoading = false
                this.bind = null

                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: 'Estabelecimento vinculado',
                    timeout: 3000,
                })
                EventBus.$emit('ESTABLISHMENT_BOUND')

                this.load()
            }
        },

        mounted() {
            this.$store.commit('USERS_SET_FILTER', {
                key: 'search',
                value: ''
            })

            if (this.items.length === 0)
                this.load()

            EventBus.$on('ESTABLISHMENT_UNBOUND', this.load)
        },

        destroyed() {
            this.$store.commit('ADVERTISERS_CLEAR_ESTABLISHMENTS')
        }
    }
</script>

<style scoped>
    .input-wrapper {
        width: 340px;
    }
    .btn-primary{
        margin-left: 15px;
    }
</style>
